import { Controller } from "@hotwired/stimulus"

/**
 * Votifierテスト送信コントローラー
 * 
 * テスト送信ボタンのクリックで非同期POSTリクエストを送信し、
 * 結果をresultターゲットに表示します。
 * 
 * Validates: Requirements 4.2, 4.3, 4.4
 */
export default class extends Controller {
  static targets = ["button", "result"]
  static values = { url: String }

  /**
   * テスト送信を実行
   * 非同期でPOSTリクエストを送信し、結果を表示
   */
  async sendTest() {
    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = "送信中..."
    this.resultTarget.innerHTML = ""

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      const data = await response.json()

      if (data.success) {
        this.resultTarget.innerHTML = `<div class="votifier-test__result votifier-test__result--success">${data.message}</div>`
      } else {
        this.resultTarget.innerHTML = `<div class="votifier-test__result votifier-test__result--error">${data.message}</div>`
      }
    } catch (error) {
      this.resultTarget.innerHTML = `<div class="votifier-test__result votifier-test__result--error">通信エラーが発生しました</div>`
    } finally {
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = "テスト送信"
    }
  }
}
